module.exports = __webpack_public_path__ + "img/4.3dd13496.png";